import React from "react";
import {
  AccessTime,
  CheckCircleOutline,
  DateRange,
  AttachMoney,
  Foundation,
  Groups,
  ModeStandby,
  Policy,
  TransferWithinAStation,
  WorkspacesOutlined,
} from "@mui/icons-material";

export const loanHistory = [
  { name: "Date", key: "applied_date" },
  //   { name: "Employee Name" },
  { name: "Loan Amount", key: "principal_amount" },
  { name: "Tenure", key: "tenure_months" },
  { name: "Interest", key: "interest_rate" },
  { name: "Total Amount", key: "monthly_installment" },
  { name: "Loan Type", key: "loan_type" },
  { name: "Interest Type", key: "interest_type" },
  { name: "Status", key: "status" },
  { name: "Action" },
];

export const viewTableData = [
  { name: "Payment Date", key: "payment_month" },
  { name: "Interest", key: "interest" },
  { name: "Installment Amount", key: "principal" },
  { name: "Total Amount", key: "amount" },
  { name: "Status", key: "status" },
  { name: "Balance", key: "remaining_balance" },
];

export const loanTypeArray = [
  {
    label: "Personal Loan",
  },
  {
    label: "Home Loan",
  },
  {
    label: "Vehicle Loan",
  },
  {
    label: "Education Loan",
  },
  {
    label: "Medical Loan",
  },
];

export const interestType = [
  {
    label: "Flat Rate",
  },
  {
    label: "Reducing Balance",
  },
];

export const tenureType = [
  {
    label: "Monthly",
  },
  {
    label: "Weekly",
  },
  {
    label: "Biweekly",
  },
];

export const myZoneLeaveHeader = [
  { name: "", key: "" },
  { name: "Leave Type", key: "leave_type" },
  { name: "Start Date", key: "from_date" },
  { name: "End Date", key: "to_date" },
  { name: "Businees Days", key: "business_days" },
  { name: "Status", key: "status" },
];

export const myZonePermissionHeader = [
  { name: "", key: "" },
  { name: "Date", key: "date" },
  { name: "Start Time", key: "start_time" },
  { name: "End Time", key: "end_time" },
  { name: "Duration", key: "total_time" },
  { name: "Status", key: "status" },
];

export const advanceSalaryHeader = [
  {
    name: "Date",
    key: "repayment_date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "repayment_date",
      toField: "repayment_date",
    },
  },
  { name: "Advance Type", key: "advance_type", type: "string" },
  {
    name: "Advance Amount",
    key: "amount",
    type: "number",
    icon: <AttachMoney fontSize="small" />,
  },
  { name: "Reason for Cash", key: "description", type: "string" },
  { name: "Status", key: "status", type: "autocomplete" },
];

export const expenseHeader = [
  { name: "Date", key: "date_incurred" },
  { name: "Expense Type", key: "expense_type" },
  { name: "Expense Amount", key: "amount" },
  { name: "Reason For Expense", key: "description" },
  { name: "Status", key: "status" },
];

export const dayoffAttendance = [
  {
    key: "shift_grade_name",
    name: "Employee ID",
  },
  {
    key: "date",
    name: "Employee Name",
  },
  {
    key: "shift",
    name: "Department",
  },
  {
    key: "check_in_time",
    name: "Applied Date",
  },
  {
    key: "type",
    name: "Type",
  },
  {
    key: "status",
    name: "Status",
  },
  {
    key: "",
    name: "Action",
  },
];

export const weekOffType = [
  {
    id: 1,
    label: "Weekly",
  },
  {
    id: 2,
    label: "On Duty",
  },
  {
    id: 2,
    label: "Field Duty",
  },
];

export const overTimePendingHeader = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "employee_name",
    name: "Name",
  },
  {
    key: "ot_date",
    name: "Date",
  },
  {
    key: "ot_duration",
    name: "Duration",
  },
  {
    key: "ot_consideration",
    name: "Consideration",
  },
  {
    key: "action",
    name: "Action",
  },
];

export const overTimeHistoryHeader = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "employee_name",
    name: "Name",
  },
  {
    key: "ot_date",
    name: "Date",
  },
  {
    key: "ot_duration",
    name: "Duration",
  },
  {
    key: "ot_consideration",
    name: "Consideration",
  },
  {
    key: "status",
    name: "Status",
  },
];

export const overTimePayrollPendingHeader = [
  {
    key: "username",
    name: "Name",
  },
  {
    key: "date",
    name: "Date",
  },
  {
    key: "overtime_start_formated",
    name: "OT Start",
  },
  {
    key: "overtime_end_formated",
    name: "OT End",
  },
  {
    key: "overtime_break_duration",
    name: " Break Duration",
  },
  {
    key: "overtime_duration",
    name: "Duration",
  },
  {
    key: "ot_consideration",
    name: "Consideration",
  },
];

export const overTimePayrollHistoryHeader = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "username",
    name: "Name",
  },
  {
    key: "date",
    name: "Date",
  },
  {
    key: "overtime_start_formated",
    name: "OT Start",
  },
  {
    key: "overtime_end_formated",
    name: "OT End",
  },
  {
    key: "overtime_break_duration",
    name: " Break Duration",
  },
  {
    key: "overtime_duration",
    name: "Duration",
  },

  {
    key: "ot_consideration",
    name: "Consideration",
  },
  {
    key: "status",
    name: "Status",
  },
];

export const IncentivePendingHeader = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "incentive_group_name",
    name: "Incentive Name",
  },
  {
    key: "incentive_type",
    name: "Incentive Type",
  },
  {
    key: "start_date",
    name: "Start Date",
  },
  {
    key: "end_date",
    name: "End Date",
  },

  {
    key: "incentive_amount",
    name: "Amount",
  },

  {
    key: "action",
    name: "Action",
  },
];

export const IncentiveHistoryHeader = [
  {
    key: "arrow",
    name: "",
  },
  {
    key: "incentive_group_name",
    name: "Incentive Name",
  },
  {
    key: "incentive_type",
    name: "Incentive Type",
  },
  {
    key: "start_date",
    name: "Start Date",
  },
  {
    key: "end_date",
    name: "End Date",
  },
  {
    key: "incentive_amount",
    name: "Amount",
  },
  {
    key: "status",
    name: "Status",
  },
  {
    key: "payrun_status",
    name: "Payrun Status",
  },
  {
    key: "payrun_month",
    name: "Payrun",
  },
];

export const applicableTiming = [
  {
    id: "Only Before",
    label: "Before Shift",
    description:
      "Allow employees to log overtime for hours worked before their scheduled shift begins.",
  },
  {
    id: "Only After",
    label: "After Shift",
    description:
      "Enable overtime entry for additional hours worked beyond the regular shift end time.",
  },
  {
    id: "Before and After",
    label: "Before and After Shift",
    description:
      "Permit overtime logging for both early start and extended work hours outside the regular shift schedule.",
  },
];

export const OTPostApprovalHeader = [
  {
    key: "expand",
    name: "",
  },
  {
    key: "date",
    name: "Date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    key: "worked_hours",
    name: "Worked Hrs",
    type: "number",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "basis",
    name: "Basis",
    type: "autocomplete",
    icon: <Foundation fontSize="small" />,
  },
  {
    key: "worked_qty",
    name: "Worked Qty",
    type: "number",
    icon: <WorkspacesOutlined fontSize="small" />,
  },
  {
    key: "approved_qty",
    name: "Approved Qty",
    type: "number",
    icon: <CheckCircleOutline fontSize="small" />,
  },
  {
    key: "payout_policy",
    name: "Payout Policy",
    type: "autocomplete",
    icon: <Policy fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <TransferWithinAStation fontSize="small" />,
  },
];

export const OTPreApprovalHeader = [
  {
    key: "expand",
    name: "",
  },
  {
    key: "ot_date",
    name: "Date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "ot_date",
      toField: "ot_date",
    },
  },
  {
    key: "ot_duration",
    name: "Duration",
    type: "time",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    key: "ot_consideration",
    name: "Applicable Timing",
    type: "autocomplete",
    icon: <Groups fontSize="small" />,
  },
  {
    key: "status",
    name: "Status",
    type: "autocomplete",
    icon: <ModeStandby fontSize="small" />,
  },
];
